<script lang="ts">
  import { onMount, createEventDispatcher } from 'svelte'
  import { fly } from 'svelte/transition'
  import { clickOutside } from '..'

	const dispatch = createEventDispatcher()

  interface CustomSelectOption {
    key: string
    title: string
    [key: string]: any
  }

  export let options: CustomSelectOption[] = [
    {
      key: 'site',
      title: 'Site Search',
      placholder: 'Search med.uc.edu',
      helpText: 'Search all of med.uc.edu',
      searchBaseUrl: '/search-results?indexCatalogue=med-2023&wordsMode=AllWords&searchQuery=',
    },
    {
      key: 'lastname',
      title: 'Last Name',
      placholder: 'Search by Last Name',
      helpText: 'Find an expert by their last name',
      searchBaseUrl: '/landing-pages/profile/IndexSearch/Alpha/',
      suggestionsBaseUrl: '/IndexJSNames/',
      suggestionsDirectBaseUrl: '/landing-pages/profile/Index/Pubs/',
    },
    {
      key: 'keyword',
      title: 'Keyword',
      placholder: 'Search by Keyword',
      helpText: 'Search College of Medicine experts by keyword',
      searchBaseUrl: '/landing-pages/profile/IndexSearch/Keyword/',
    },
    {
      key: 'specialty',
      title: 'Specialty',
      placholder: 'Search by Specialty',
      helpText: 'Search College of Medicine experts by specialty',
      searchBaseUrl: '/landing-pages/profile/IndexSearch/Specialty/',
      suggestionsBaseUrl: '/IndexJSSpecialty/',
      suggestionsDirectBaseUrl: '/landing-pages/profile/IndexSearch/Specialty/',
    },
  ]

  let selectedKey: string
  $: if(selectedKey) {
    dispatch('NEW_SEARCH_KEY', selectedKey)
    showOptions = false
  }

  let showOptions: boolean = false
  $: activeTitle = options.find((option)=> option.key === selectedKey)?.title || 'Choose one'

  let choiceButtonUI

  onMount(()=> {
    // set the selected key to the first option
    selectedKey = options[0].key
  })
</script>

<div class="custom-select">
  <button 
    on:click={()=> showOptions = !showOptions}
    bind:this={choiceButtonUI}
  >
    <span class="grow">{ activeTitle }</span> <span class="shrink"><i class="fa-duotone fa-chevron-down"></i></span>
  </button>
  {#if showOptions}
    <ul 
      class="options" 
      transition:fly
      use:clickOutside={{desktopTriggerElement: choiceButtonUI}}
      on:CLICK_OUTSIDE={()=> showOptions = false}  
    >
      {#each options as _}
        {#if selectedKey !== _.key}
          <li>
            <button
              data-value="{_.key}"
              on:click={()=> selectedKey = _.key}
            >
              {_.title}
            </button>
          </li>
        {/if}
      {/each}
    </ul>
  {/if}
</div>

<style lang="scss">
  .custom-select {
    position: relative;
    height: 100%;
    min-width: 152px;

    button {
      display: block;
      height: 100%;
      font-size: 2rem;
      line-height: 2rem;
      text-wrap: nowrap;
      text-align: left;
      width: 100%;
      padding: 1rem 1.5rem;
      border: none;
      background-color: white;
    }

    > button {
      display: flex;
      align-items: center;
      padding: 1rem;
      font-size: 2rem;
      line-height: 2rem;
      background-color: var(--uc-red);
      color: white;
      border-radius: 1rem 0 0 1rem;
    }

    ul.options {
      position: absolute;
      list-style: none;
      width: 100%;
      z-index: 1;
      margin: 0;
      padding-left: 1rem;
      
      li {
        padding: 0;
        
        &:last-child button{ 
          border-radius: 0 0 1.5rem 1.5rem;
          padding-bottom: 1.5rem;
        }
        
        button {
          font-size: 1.6rem;
          
          &:hover, &:focus {
            background-color: var(--bearcat-black);
            color: white;
          }
        }
      }
    }
  }
</style>
